{
  "name": "@mv_rpp/reza-ais-fe",
  "version": "1.8.0-6",
  "license": "MIT",
  "scripts": {
    "start": "npx nx serve reza-ais-fe",
    "test:dev": "npm --prefix apps/reza-ais-playwright run test:dev --",
    "build": "npx nx build reza-ais-fe --configuration=production",
    "build.dev": "npx nx build reza-ais-fe -c dev",
    "build.prod": "npx nx build reza-ais-fe",
    "build.test": "npx nx build reza-ais-fe",
    "decode-be-json": "node libs/reza-ais-fe/generated/source/decode-url.js http://rpp-dev-vm1.assecosk.local:32700/reza-ais-be/rest/v3/api-docs libs/reza-ais-fe/generated/source/api-be-decode.json",
    "generate-api-be": "npm run decode-be-json && npm run clean-api-be-output && openapi-generator-cli generate -i ./libs/reza-ais-fe/generated/source/api-be-decode.json -g typescript-angular -o ./libs/reza-ais-fe/generated/be-service/src --template-dir ./libs/reza-ais-fe/generated/source/templates/typescript-angular --additional-properties=ngVersion=17.3.0,fileNaming=kebab-case,npmName=reza-ng-api-be,supportsES6=true,npmVersion=10.5.2,providedIn=none,useSingleRequestParameter=true,stringEnums=true,withInterfaces=true,basePath=/api --global-property=skipFormModel=false",
    "decode-be-json2": "node libs/reza-ais-fe/generated/source/decode-file.js libs/reza-ais-fe/generated/source/swagger-test.json libs/reza-ais-fe/generated/source/api-be-decode2.json",
    "generate-api-be2": "npm run decode-be-json2 && openapi-generator-cli generate -i ./libs/reza-ais-fe/generated/source/api-be-decode2.json -g typescript-angular -o ./libs/reza-ais-fe/generated/be-service/src --additional-properties=ngVersion=17.3.0,fileNaming=kebab-case,npmName=reza-ng-api-be,supportsES6=true,npmVersion=10.5.2,providedIn=none,useSingleRequestParameter=true,stringEnums=true,withInterfaces=true,basePath=/api --global-property=skipFormModel=false",
    "clean-api-be-output": "rimraf ./libs/reza-ais-fe/generated/be-service/src",
    "make-it-pretty": "prettier --write \"./**/*.{ts,css,html}\"",
    "generate-sbom": "cyclonedx-npm --output-file reza_fe_sbom.json --ignore-npm-errors package.json"
  },
  "private": false,
  "publishConfig": {
    "tag": "latest"
  },
  "files": [
    "dist/apps/reza-ais-fe/browser"
  ],
  "dependencies": {
    "@angular/cdk": "22.2.5",
    "@angular/common": "22.2.4",
    "@angular/compiler": "22.2.4",
    "@angular/core": "22.2.4",
    "@angular/forms": "22.2.4",
    "@angular/platform-browser": "22.2.4",
    "@angular/router": "22.2.4",
    "@gov-design-system-ce/fonts": "4.7.3",
    "@openng/icons": "^1.0.0",
    "@openng/optimus-ui": "2.0.2",
    "@openng/optimus-ui-tailwindcss": "2.0.2",
    "@openng/optimus-ui-themes": "2.0.2",
    "date-fns": "^4.1.0",
    "echarts": "^6.1.0",
    "lodash-es": "^4.17.21",
    "ngx-echarts": "^22.0.0",
    "quill": "npm:quill-next@2.2.6",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular-devkit/core": "22.2.5",
    "@angular-devkit/schematics": "22.2.5",
    "@angular-eslint/eslint-plugin": "22.6.0",
    "@angular-eslint/eslint-plugin-template": "22.6.0",
    "@angular-eslint/template-parser": "22.6.0",
    "@angular/build": "22.2.5",
    "@angular/cli": "22.2.5",
    "@angular/compiler-cli": "22.2.4",
    "@angular/language-service": "22.2.4",
    "@cyclonedx/cyclonedx-npm": "6.0.1",
    "@eslint/js": "^10.0.1",
    "@nx/angular": "24.0.0",
    "@nx/eslint": "24.0.0",
    "@nx/eslint-plugin": "24.0.0",
    "@nx/jest": "24.0.0",
    "@nx/js": "24.0.0",
    "@nx/web": "24.0.0",
    "@nx/workspace": "24.0.0",
    "@openapitools/openapi-generator-cli": "2.42.0",
    "@schematics/angular": "22.2.5",
    "@swc-node/register": "1.12.1",
    "@swc/core": "1.16.2",
    "@swc/helpers": "0.5.23",
    "@tailwindcss/postcss": "4.3.3",
    "@types/jest": "30.0.0",
    "@types/lodash-es": "^4.17.6",
    "@types/node": "24.19.2",
    "@typescript-eslint/eslint-plugin": "^8.71.2",
    "@typescript-eslint/parser": "^8.71.2",
    "@typescript-eslint/utils": "^8.71.2",
    "angular-eslint": "^22.6.0",
    "eslint": "^10.13.0",
    "eslint-config-prettier": "10.1.8",
    "globals": "16.5.0",
    "he": "^1.2.0",
    "jest": "30.5.2",
    "jest-environment-jsdom": "30.5.2",
    "jest-preset-angular": "17.0.3",
    "jsonc-eslint-parser": "2.4.2",
    "lodash": "4.18.1",
    "nx": "24.0.0",
    "postcss": "8.5.30",
    "prettier": "3.9.10",
    "rimraf": "^6.1.3",
    "tailwindcss": "4.3.3",
    "ts-jest": "29.4.15",
    "ts-node": "10.9.1",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.71.2"
  },
  "volta": {
    "node": "24.22.0"
  },
  "overrides": {
    "basic-ftp": "6.2.5",
    "glob": "14.0.3",
    "nx": {
      "undici": "7.30.1"
    },
    "@oxc-parser/binding-wasm32-wasi": {
      "@emnapi/core": "2.0.0-beta.3",
      "@emnapi/runtime": "2.0.0-beta.3"
    }
  },
  "allowScripts": {
    "@openapitools/openapi-generator-cli": false,
    "libxmljs2": false,
    "@parcel/watcher@2.6.0": true,
    "@swc/core@1.16.2": true,
    "esbuild@0.28.2": true,
    "fsevents@2.3.3": true,
    "lmdb@3.5.6": true,
    "msgpackr-extract@3.0.4": true,
    "nx@24.0.0": true,
    "unrs-resolver@1.12.2": true
  }
}
